.distribution-bar-container {
    display: flex;
    height: 72px;
    width: 100%;
    background-color: var(--white);
    overflow: hidden; /* Ensures the inner bars don't spill out of the container's rounded corners */
    border-radius: 3px;
    border: 1px solid var(--off-white-dk);
}

.distribution-bar-container--mini {
    composes: distribution-bar-container;
    height: 12px;
    border-radius: 16px;
    border: none;
}

.distribution-bar-container--dark {
    composes: distribution-bar-container;
    border-color: var(--button-secondary-dk);
}

.distribution-bar-container--compact {
    height: 55px;
}

.bar-section {
    transition: width 0.3s ease;
    padding: 12px 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.bar-section--mini {
    padding: 0 0 0 8px;
}

.bar-section--hoverable {
    cursor: pointer;
}

.bar-section--hoverable:hover {
    opacity: 0.7;
}

.bar-section-equal {
    flex: 1;
    padding: 12px 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
}
